/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface NotificationStatusCategory
 */
export interface NotificationStatusCategory {
    /**
     * 알림 상태 id
     * @type {number}
     * @memberof NotificationStatusCategory
     */
    'notificationStatusCategoryId': number;
    /**
     * 카테고리
     * @type {string}
     * @memberof NotificationStatusCategory
     */
    'category': NotificationStatusCategoryCategoryEnum;
}

export const NotificationStatusCategoryCategoryEnum = {
    Reservation: 'reservation',
    Progress: 'progress',
    Success: 'success',
    Fail: 'fail',
    Cancel: 'cancel',
    Wait: 'wait'
} as const;

export type NotificationStatusCategoryCategoryEnum = typeof NotificationStatusCategoryCategoryEnum[keyof typeof NotificationStatusCategoryCategoryEnum];


